// Reusable image pools
const SMILE = "/images/smile.jpg";
const CLINIC = "/images/clinic.jpg";
const RECEPTION = "/images/reception.jpg";
const TOOLS = "/images/tools.jpg";
const INSTR = "/images/instr.jpg";
const PROC = "/images/proc.jpg";

const gallery = [SMILE, CLINIC, INSTR];

const ORTHO = ["/ortho/ortho1.jpg", "/ortho/ortho2.jpg", "/ortho/ortho3.jpg", "/ortho/ortho4.jpg"];
const PEDO = ["/pedo/pedo2.jpg", "/pedo/pedo3.jpg", "/pedo/pedo5.jpg", "/pedo/pedo6.jpg", "/pedo/pedo8.jpg", "/pedo/pedo10.jpg"];
const WHITEN_VIDEOS = [
  "https://www.facebook.com/plugins/video.php?height=533&href=https%3A%2F%2Fwww.facebook.com%2F61558979597790%2Fvideos%2F1326107081931885%2F&show_text=false&width=300&t=0",
  "https://www.facebook.com/plugins/video.php?height=533&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1444319056999332%2F&show_text=false&width=300&t=0",
];

export const SERVICES = [
  {
    slug: "dental-implants",
    name: "Dental Implants",
    icon: "Anchor",
    tagline: "Permanent teeth, indistinguishable from nature.",
    hero: CLINIC,
    seoTitle: "Dental Implants — Permanent Tooth Replacement",
    seoDesc: "Premium single, multiple and full-arch dental implants at Glamour Dent. Natural-looking, permanent results delivered by master implantologists.",
    description:
      "Dental implants are the gold standard for replacing missing teeth. A biocompatible titanium post is placed into the jawbone to act as a new root, crowned with a hand-crafted porcelain tooth that looks, feels and functions exactly like your own.",
    benefits: [
      "A permanent solution that can last a lifetime",
      "Preserves jawbone and facial structure",
      "Restores full bite strength and confidence",
      "Indistinguishable from natural teeth",
    ],
    procedure: [
      { t: "3D Assessment", d: "A detailed CT scan maps your bone and nerves for precise, guided placement." },
      { t: "Implant Placement", d: "The titanium post is placed under gentle local anaesthetic in a single comfortable visit." },
      { t: "Healing & Integration", d: "The implant fuses with the bone over a few weeks, forming a stable foundation." },
      { t: "The Final Crown", d: "A bespoke porcelain crown is fitted and colour-matched to your smile." },
    ],
    recovery:
      "Most guests return to daily life the following day. Mild swelling settles within 48 hours, and our team provides a soft-food plan and priority follow-ups throughout integration.",
    faq: [
      { q: "Are implants painful?", a: "Placement is performed under local anaesthetic — most patients report minimal discomfort afterwards." },
      { q: "How long do implants last?", a: "With good care, implants can last a lifetime. The crown may be refreshed after 15–20 years." },
    ],
    gallery,
  },
  {
    slug: "teeth-whitening",
    name: "Teeth Whitening",
    icon: "Sparkles",
    tagline: "Several shades brighter in a single visit.",
    hero: SMILE,
    seoTitle: "Professional Teeth Whitening — Same-Day Results",
    seoDesc: "Safe, professional teeth whitening at Glamour Dent. Brighten your smile by several shades in a single luxurious in-clinic session.",
    description:
      "Our professional whitening lifts years of staining from coffee, wine and time in a single, comfortable session. Using medically-graded systems and custom protection, we brighten your smile safely and evenly for a luminous, natural result.",
    benefits: [
      "Visible results in one appointment",
      "Enamel-safe, dentist-supervised system",
      "Even, natural-looking brightness",
      "Take-home maintenance kit included",
    ],
    procedure: [
      { t: "Shade Analysis", d: "We record your starting shade and set a realistic, flattering target." },
      { t: "Gum Protection", d: "A protective barrier shields your gums for total comfort." },
      { t: "Activation", d: "A premium whitening gel is activated in gentle cycles." },
      { t: "The Reveal", d: "We reveal your new shade and fit custom maintenance trays." },
    ],
    recovery:
      "There is no downtime. Some guests notice brief sensitivity that fades within a day; we recommend a light-coloured diet for 24 hours to lock in the result.",
    faq: [
      { q: "Is whitening safe for enamel?", a: "Yes — our supervised, medically-graded system is designed to protect enamel while lifting stains." },
      { q: "How long do results last?", a: "Typically 12–18 months, extended easily with your take-home maintenance kit." },
    ],
    videos: WHITEN_VIDEOS,
    gallery,
  },
  {
    slug: "veneers",
    name: "Veneers",
    icon: "Gem",
    tagline: "Bespoke porcelain, designed around your face.",
    hero: "/images/veneer.jpg",
    seoTitle: "Porcelain Veneers — Bespoke Smile Design",
    seoDesc: "Hand-crafted porcelain veneers at Glamour Dent. Minimal-prep, natural-looking smile design tailored to your facial features.",
    description:
      "Veneers are wafer-thin shells of hand-crafted porcelain bonded to the front of your teeth to perfect their shape, colour and alignment. Our minimal-prep approach preserves your natural teeth while delivering a flawless, cohesive smile.",
    benefits: [
      "Transforms shape, shade and alignment at once",
      "Minimal-prep, tooth-preserving technique",
      "Stain-resistant, life-like porcelain",
      "A completely bespoke smile design",
    ],
    procedure: [
      { t: "Smile Design", d: "We digitally design your new smile and preview it before we begin." },
      { t: "Gentle Preparation", d: "A minimal layer is refined to make room for the porcelain." },
      { t: "Master Crafting", d: "Ceramists hand-build each veneer for a natural, layered translucency." },
      { t: "Bonding", d: "Veneers are precision-bonded and polished to a flawless finish." },
    ],
    recovery:
      "You can eat and speak normally the same day. It is common to adjust to the new feel over a few days; there is no meaningful downtime.",
    faq: [
      { q: "Will veneers look natural?", a: "Absolutely — we layer porcelain to mimic natural translucency and design around your facial features." },
      { q: "Do veneers damage my teeth?", a: "Our minimal-prep technique preserves the maximum amount of your natural tooth structure." },
    ],
    gallery,
  },
  {
    slug: "orthodontics",
    name: "Orthodontics",
    icon: "AlignHorizontalDistributeCenter",
    tagline: "Invisible alignment for a discreet transformation.",
    hero: "/ortho/ortho1.jpg",
    seoTitle: "Orthodontics & Clear Aligners — Discreet Straightening",
    seoDesc: "Discreet clear aligner orthodontics at Glamour Dent. Straighten your smile invisibly with a tailored, adult-friendly treatment plan.",
    description:
      "Modern orthodontics no longer means metal. Our clear aligner systems gently and invisibly guide your teeth into perfect alignment, with a discreet, removable approach designed for busy, adult lifestyles.",
    benefits: [
      "Virtually invisible clear aligners",
      "Removable for eating and cleaning",
      "Predictable, digitally-planned results",
      "Fewer appointments than traditional braces",
    ],
    procedure: [
      { t: "Digital Scan", d: "A quick intraoral scan builds a precise 3D model of your bite." },
      { t: "Treatment Preview", d: "See a simulation of your final smile before you commit." },
      { t: "Aligner Series", d: "Wear a sequence of custom aligners, each moving teeth gently." },
      { t: "Retention", d: "A discreet retainer keeps your new smile perfectly in place." },
    ],
    recovery:
      "Aligners cause only brief pressure when switching trays. Daily life continues uninterrupted throughout the entire treatment.",
    faq: [
      { q: "How long does treatment take?", a: "Most cases complete within 6–14 months depending on complexity." },
      { q: "Will aligners affect my speech?", a: "Any brief adjustment typically resolves within a day or two of wearing them." },
    ],
    gallery: ORTHO,
  },
  {
    slug: "dental-hygiene",
    name: "Dental Hygiene",
    icon: "Droplets",
    tagline: "The ritual that keeps your smile flawless.",
    hero: INSTR,
    seoTitle: "Dental Hygiene & Cleaning — Preventive Care",
    seoDesc: "Luxury dental hygiene and preventive cleaning at Glamour Dent. Gentle, thorough care to keep your smile healthy and radiant.",
    description:
      "Exceptional smiles are maintained, not just created. Our hygiene appointments blend meticulous cleaning, gentle stain removal and preventive guidance in a calm, spa-like setting that leaves your smile feeling immaculate.",
    benefits: [
      "Removes plaque, tartar and surface staining",
      "Protects against gum disease and decay",
      "Fresh, polished, healthy-feeling smile",
      "Personalised home-care coaching",
    ],
    procedure: [
      { t: "Assessment", d: "We review gum health and screen for any early concerns." },
      { t: "Deep Clean", d: "Gentle ultrasonic scaling removes build-up with total comfort." },
      { t: "Polish & Refresh", d: "A fine polish lifts surface stains for a bright finish." },
      { t: "Guidance", d: "Tailored advice keeps your smile pristine between visits." },
    ],
    recovery:
      "There is no downtime at all — you leave with a fresh, polished smile and can resume your day immediately.",
    faq: [
      { q: "How often should I visit?", a: "We recommend a hygiene visit every six months, or more often for tailored care plans." },
      { q: "Is scaling uncomfortable?", a: "Our gentle ultrasonic technique is designed for a comfortable, relaxing experience." },
    ],
    gallery,
  },
  {
    slug: "prosthetics",
    name: "Prosthetics",
    icon: "Crown",
    tagline: "Crowns and bridges crafted to perfection.",
    hero: TOOLS,
    seoTitle: "Dental Prosthetics — Crowns, Bridges & Dentures",
    seoDesc: "Bespoke dental prosthetics at Glamour Dent — crowns, bridges and precision dentures crafted for comfort, function and natural beauty.",
    description:
      "When teeth need rebuilding, our prosthetic work restores both function and beauty. From individual porcelain crowns to elegant bridges and precision dentures, every piece is hand-crafted to blend seamlessly with your natural smile.",
    benefits: [
      "Restores full chewing function",
      "Hand-crafted, colour-matched porcelain",
      "Durable, long-lasting materials",
      "Natural, comfortable fit",
    ],
    procedure: [
      { t: "Assessment", d: "We evaluate the tooth and design the ideal restoration." },
      { t: "Precision Prep", d: "The tooth is gently shaped for a perfect, lasting fit." },
      { t: "Master Crafting", d: "Ceramists build your prosthetic for strength and beauty." },
      { t: "Fitting", d: "The restoration is fitted, adjusted and polished to perfection." },
    ],
    recovery:
      "Temporary restorations let you function normally between visits. Once the final piece is fitted, you can eat and smile with full confidence right away.",
    faq: [
      { q: "How long do crowns last?", a: "With good care, quality porcelain crowns typically last 15 years or more." },
      { q: "Will it match my other teeth?", a: "Yes — every restoration is colour-matched and shaped to blend seamlessly." },
    ],
    gallery,
  },
  {
    slug: "endodontics",
    name: "Endodontics",
    icon: "Microscope",
    tagline: "Painless, microscope-guided root canal therapy.",
    hero: PROC,
    seoTitle: "Endodontics — Painless Root Canal Treatment",
    seoDesc: "Microscope-guided endodontic and root canal treatment at Glamour Dent. Save your natural tooth in comfort with precision specialists.",
    description:
      "Root canal therapy has been transformed by technology. Using surgical microscopes and gentle techniques, our endodontists relieve pain and save your natural tooth in a calm, comfortable and remarkably precise procedure.",
    benefits: [
      "Saves your natural tooth",
      "Relieves pain and infection",
      "Microscope-guided precision",
      "Comfortable, gentle care",
    ],
    procedure: [
      { t: "Diagnosis", d: "Digital imaging pinpoints the source of discomfort." },
      { t: "Gentle Access", d: "The tooth is numbed and gently opened under the microscope." },
      { t: "Cleaning & Sealing", d: "Canals are meticulously cleaned, shaped and sealed." },
      { t: "Restoration", d: "The tooth is rebuilt, often with a protective crown." },
    ],
    recovery:
      "Most discomfort resolves within a day or two. Over-the-counter relief is usually sufficient, and we schedule a priority check to confirm full healing.",
    faq: [
      { q: "Is a root canal painful?", a: "Modern root canals are no more uncomfortable than a filling and actually relieve existing pain." },
      { q: "Will I need a crown afterwards?", a: "Often yes — a crown protects the treated tooth and restores full strength." },
    ],
    gallery,
  },
  {
    slug: "pediatric-dentistry",
    name: "Pediatric Dentistry",
    icon: "Baby",
    tagline: "Gentle, joyful care for young smiles.",
    hero: "/pedo/pedo4.jpg",
    seoTitle: "Pediatric Dentistry — Gentle Care for Children",
    seoDesc: "Warm, gentle pediatric dentistry at Glamour Dent. A calm, reassuring environment that helps children build healthy smiles for life.",
    description:
      "We make dentistry a positive experience from the very first visit. Our pediatric specialists create a warm, playful and reassuring environment that helps children feel safe, building healthy habits and confident smiles for life.",
    benefits: [
      "Warm, child-friendly specialists",
      "Preventive care and gentle guidance",
      "Calm, reassuring environment",
      "Builds lifelong healthy habits",
    ],
    procedure: [
      { t: "Friendly Welcome", d: "We introduce your child to the practice at their own pace." },
      { t: "Gentle Check-up", d: "A relaxed, playful examination of growing teeth." },
      { t: "Preventive Care", d: "Cleaning, sealants and fluoride to protect young smiles." },
      { t: "Happy Habits", d: "Fun coaching on brushing and diet for parents and children." },
    ],
    recovery:
      "Routine visits require no downtime. We always send your child home with a smile and simple, supportive guidance for parents.",
    faq: [
      { q: "When should my child first visit?", a: "We recommend a first visit by their first birthday, or as soon as teeth appear." },
      { q: "How do you handle nervous children?", a: "Our specialists are trained in gentle, positive techniques to build trust and comfort." },
    ],
    gallery: PEDO,
  },
  {
    slug: "oral-surgery",
    name: "Oral Surgery",
    icon: "Stethoscope",
    tagline: "Advanced surgical care in expert hands.",
    hero: CLINIC,
    seoTitle: "Oral Surgery — Extractions & Advanced Procedures",
    seoDesc: "Expert oral surgery at Glamour Dent — wisdom teeth, extractions and advanced procedures performed with precision and comfort.",
    description:
      "From wisdom teeth to complex extractions and bone grafting, our oral surgeons deliver advanced surgical care with precision and calm. Effective anaesthesia and meticulous aftercare ensure the most comfortable experience possible.",
    benefits: [
      "Expert surgical specialists",
      "Effective anaesthesia and comfort",
      "Precise, minimally-invasive techniques",
      "Comprehensive aftercare support",
    ],
    procedure: [
      { t: "Consultation", d: "3D imaging plans the safest, most precise approach." },
      { t: "Comfort First", d: "Effective local anaesthetic ensures total comfort." },
      { t: "The Procedure", d: "Surgery is performed with meticulous, gentle technique." },
      { t: "Aftercare", d: "A clear recovery plan and priority follow-ups." },
    ],
    recovery:
      "Recovery varies by procedure but typically spans a few days of rest and soft foods. We provide detailed guidance and remain available throughout.",
    faq: [
      { q: "Will I feel pain during surgery?", a: "No — procedures are performed under effective local anaesthetic to keep you comfortable throughout." },
      { q: "How long is recovery?", a: "Most guests recover within a few days with our structured aftercare plan." },
    ],
    gallery,
  },
  {
    slug: "emergency-dentistry",
    name: "Emergency Dentistry",
    icon: "Siren",
    tagline: "Immediate relief when you need it most.",
    hero: RECEPTION,
    seoTitle: "Emergency Dentistry — Same-Day Urgent Care",
    seoDesc: "Same-day emergency dental care at Glamour Dent. Rapid, compassionate treatment for pain, trauma and urgent dental problems.",
    description:
      "Dental emergencies never wait, and neither do we. Whether it's sudden pain, a broken tooth or trauma, our team provides rapid, compassionate same-day care to relieve discomfort and protect your smile.",
    benefits: [
      "Same-day urgent appointments",
      "Rapid pain relief",
      "Compassionate, calm care",
      "Full follow-up treatment planning",
    ],
    procedure: [
      { t: "Immediate Contact", d: "Call our concierge and we prioritise your care." },
      { t: "Rapid Assessment", d: "We quickly diagnose the issue and relieve pain." },
      { t: "Stabilise", d: "We treat the emergency and protect the tooth." },
      { t: "Plan Ahead", d: "We arrange any follow-up to restore full health." },
    ],
    recovery:
      "After emergency relief, recovery depends on the treatment provided. We always outline clear next steps and schedule prompt follow-up care.",
    faq: [
      { q: "What counts as an emergency?", a: "Severe pain, swelling, bleeding, trauma or a broken or knocked-out tooth all warrant urgent care." },
      { q: "How fast can I be seen?", a: "We reserve same-day slots for emergencies — call our concierge line right away." },
    ],
    gallery,
  },
  {
    slug: "consultations",
    name: "Consultations & Treatment Plans",
    icon: "ClipboardCheck",
    tagline: "Your personalised roadmap to a healthier smile.",
    hero: RECEPTION,
    seoTitle: "Dental Consultations & Personalised Treatment Plans",
    seoDesc: "Book a dental consultation at Glamour Dent. A full digital assessment and a personalised, transparent treatment plan tailored to your goals.",
    description:
      "Every great result begins with a thorough consultation. We take the time to understand your goals, complete a full digital assessment, and build a clear, personalised treatment plan — with transparent options and no pressure.",
    benefits: [
      "Unhurried, one-to-one assessment",
      "Full digital diagnostics",
      "A clear, personalised plan",
      "Transparent costs and options",
    ],
    procedure: [
      { t: "Conversation", d: "We listen to your concerns, goals and dental history." },
      { t: "Digital Assessment", d: "Scans and imaging give a complete picture of your smile." },
      { t: "Your Plan", d: "We design a step-by-step, personalised treatment plan." },
      { t: "Next Steps", d: "You leave with clear options, timeline and costs." },
    ],
    recovery:
      "A consultation requires no downtime — it is a relaxed, informative visit that leaves you confident about your options and next steps.",
    faq: [
      { q: "How long does a consultation take?", a: "Typically 30–45 minutes, so we can assess thoroughly and answer every question." },
      { q: "Am I obliged to proceed with treatment?", a: "Never. Your plan is provided with no obligation, so you can decide in your own time." },
    ],
    gallery,
  },
  {
    slug: "restorative-dentistry",
    name: "Restorative Dentistry",
    icon: "Layers",
    tagline: "Repairing decay, restoring strength and beauty.",
    hero: INSTR,
    seoTitle: "Restorative Dentistry — Fillings & Dental Restorations",
    seoDesc: "Restorative dentistry at Glamour Dent — gentle cavity treatment and natural, tooth-coloured fillings and restorations that look and feel like your own teeth.",
    description:
      "Restorative dentistry treats decay and damage to bring teeth back to full health, strength and beauty. Using tooth-coloured, mercury-free materials, we repair cavities and restore teeth so seamlessly that the result is virtually invisible.",
    benefits: [
      "Natural, tooth-coloured fillings",
      "Gentle, minimally-invasive technique",
      "Restores full strength and function",
      "Modern, mercury-free materials",
    ],
    procedure: [
      { t: "Diagnosis", d: "We detect decay early with careful examination and imaging." },
      { t: "Gentle Preparation", d: "The area is numbed and the decay gently removed." },
      { t: "Restoration", d: "A tooth-coloured material is layered and sculpted to shape." },
      { t: "Polish", d: "The restoration is polished to blend seamlessly with your smile." },
    ],
    recovery:
      "Most fillings involve no downtime; any mild sensitivity settles within a day. You can usually eat and drink shortly after your visit.",
    faq: [
      { q: "Are your fillings noticeable?", a: "No — we use tooth-coloured composite that blends invisibly with your natural teeth." },
      { q: "Does treating a cavity hurt?", a: "Treatment is performed under local anaesthetic and is typically very comfortable." },
    ],
    gallery,
  },
  {
    slug: "custom-appliances",
    name: "Custom Trays & Appliances",
    icon: "Shield",
    tagline: "Bespoke protection, crafted to fit perfectly.",
    hero: TOOLS,
    seoTitle: "Custom Dental Trays, Nightguards & Appliances",
    seoDesc: "Custom-made dental trays, nightguards and appliances at Glamour Dent — precision-fitted from digital scans to protect your teeth and support your treatment.",
    description:
      "From whitening trays to nightguards and sports mouthguards, our custom appliances are crafted from precise digital scans for a comfortable, exact fit — protecting your teeth from grinding, injury and wear.",
    benefits: [
      "Precision digital-scan fit",
      "Protects against grinding and injury",
      "Comfortable, discreet design",
      "Durable, long-lasting materials",
    ],
    procedure: [
      { t: "Digital Scan", d: "A quick, comfortable scan captures your exact bite." },
      { t: "Custom Crafting", d: "Your appliance is made to millimetre precision." },
      { t: "Fitting", d: "We fit and fine-tune for total comfort." },
      { t: "Care Guidance", d: "Simple advice keeps your appliance in perfect condition." },
    ],
    recovery:
      "There is no downtime — appliances are ready to use immediately, with a short, natural adjustment period for night-time wear.",
    faq: [
      { q: "What appliances do you make?", a: "Whitening trays, nightguards for grinding, sports mouthguards and retainers, all custom-fitted." },
      { q: "How long do they last?", a: "With good care, most appliances last several years; we'll advise on replacement when needed." },
    ],
    gallery,
  },
];

const RO_OVR = {
  "dental-implants": { name: "Implanturi Dentare", tagline: "Dinți permanenți, imposibil de deosebit de cei naturali.", description: "Implanturile dentare sunt standardul de aur pentru înlocuirea dinților lipsă. Un șurub din titan biocompatibil este plasat în os pentru a acționa ca o rădăcină nouă, acoperit cu o coroană din porțelan care arată și funcționează exact ca dintele tău." },
  "teeth-whitening": { name: "Albire Dentară", tagline: "Cu câteva nuanțe mai luminos, într-o singură vizită.", description: "Albirea profesională elimină ani de pete de cafea, vin și timp într-o singură ședință confortabilă. Folosind sisteme medicale și protecție personalizată, îți luminăm zâmbetul sigur și uniform, pentru un rezultat luminos și natural." },
  "veneers": { name: "Fațete Dentare", tagline: "Porțelan personalizat, creat în jurul feței tale.", description: "Fațetele sunt învelișuri subțiri din porțelan lucrat manual, aplicate pe fața dinților pentru a le perfecționa forma, culoarea și alinierea. Abordarea minim-invazivă îți păstrează dinții naturali oferind un zâmbet impecabil și armonios." },
  "orthodontics": { name: "Ortodonție", tagline: "Aliniere invizibilă pentru o transformare discretă.", description: "Ortodonția modernă nu mai înseamnă metal. Sistemele noastre de aligneri transparenți ghidează delicat și invizibil dinții către alinierea perfectă, cu o abordare discretă și detașabilă, potrivită vieții active a adulților." },
  "dental-hygiene": { name: "Igienă Dentară", tagline: "Ritualul care îți păstrează zâmbetul impecabil.", description: "Zâmbetele excepționale se întrețin, nu doar se creează. Ședințele de igienă îmbină o curățare meticuloasă, îndepărtarea petelor și sfaturi preventive într-un cadru calm, de spa, lăsând zâmbetul impecabil." },
  "prosthetics": { name: "Protetică Dentară", tagline: "Coroane și punți create la perfecțiune.", description: "Când dinții au nevoie de reconstrucție, lucrările noastre protetice redau atât funcția, cât și frumusețea. De la coroane individuale din porțelan la punți elegante și proteze de precizie, fiecare piesă este lucrată manual." },
  "endodontics": { name: "Endodonție", tagline: "Tratament de canal nedureros, ghidat la microscop.", description: "Tratamentul de canal a fost transformat de tehnologie. Folosind microscoape chirurgicale și tehnici blânde, endodonții noștri elimină durerea și îți salvează dintele natural într-o procedură calmă și remarcabil de precisă." },
  "pediatric-dentistry": { name: "Stomatologie Pediatrică", tagline: "Îngrijire blândă și veselă pentru zâmbete mici.", description: "Facem din stomatologie o experiență pozitivă de la prima vizită. Specialiștii noștri creează un mediu cald și liniștitor care îi ajută pe copii să se simtă în siguranță, formând obiceiuri sănătoase și zâmbete pline de încredere." },
  "oral-surgery": { name: "Chirurgie Orală", tagline: "Îngrijire chirurgicală avansată în mâini experte.", description: "De la molarii de minte la extracții complexe și adiții osoase, chirurgii noștri oferă îngrijire avansată cu precizie și calm. Anestezia eficientă și îngrijirea meticuloasă asigură cea mai confortabilă experiență posibilă." },
  "emergency-dentistry": { name: "Urgențe Stomatologice", tagline: "Alinare imediată atunci când ai nevoie.", description: "Urgențele dentare nu așteaptă, și nici noi. Fie că e vorba de durere bruscă, un dinte spart sau un traumatism, echipa noastră oferă îngrijire rapidă și empatică în aceeași zi, pentru a alina disconfortul și a-ți proteja zâmbetul." },
  "consultations": { name: "Consultații & Planuri de Tratament", tagline: "Harta ta personalizată către un zâmbet sănătos.", description: "Fiecare rezultat de excepție începe cu o consultație atentă. Ne acordăm timp să îți înțelegem obiectivele, realizăm o evaluare digitală completă și construim un plan de tratament clar și personalizat — cu opțiuni transparente și fără presiune." },
  "restorative-dentistry": { name: "Stomatologie Restaurativă", tagline: "Tratăm caria, redăm rezistența și frumusețea.", description: "Stomatologia restaurativă tratează caria și deteriorările pentru a readuce dinții la sănătate, rezistență și frumusețe deplină. Folosind materiale fizionomice, fără mercur, reparăm cariile atât de natural încât rezultatul este practic invizibil." },
  "custom-appliances": { name: "Gutiere & Aparate Personalizate", tagline: "Protecție personalizată, creată să se potrivească perfect.", description: "De la gutiere de albire la gutiere de noapte și protecții sportive, aparatele noastre personalizate sunt create pe baza scanărilor digitale precise, pentru o potrivire confortabilă și exactă — protejând dinții de bruxism, accidentări și uzură." },
};

export const SP_LABELS = {
  ro: { treatment: "Tratament", overview: "Prezentare", theTreatment: "Tratamentul", benefits: "Beneficii cheie", procedureEye: "Procedura", procedureTitle: "Cum ", procedureGold: "funcționează.", recoveryEye: "Recuperare & Îngrijire", recoveryTitle: "Vindecare în confort", faqTitle: "Întrebări & ", faqGold: "răspunsuri.", ctaPre: "Pregătit pentru", ctaP: "Vorbește cu echipa noastră concierge și programează-ți consultația privată azi.", allServices: "Toate serviciile", explore: "Explorează mai mult", discover: "Descoperă", servicesTitle1: "Fiecare tratament, un", servicesTitle2a: "exercițiu de ", servicesTitle2gold: "excelență.", servicesLead: "Explorează gama completă de servicii dentare de lux — implanturi, fațete, albire, ortodonție și multe altele.", notSurePre: "Nu știi de unde ", notSureGold: "să începi?", notSureP: "Echipa noastră concierge te va ghida către tratamentul potrivit. Un singur telefon este suficient.", home: "Acasă", services: "Servicii", call: "Sună la", videoEye: "Urmărește", videoTitle: "Vezi rezultatele" },
  en: { treatment: "Treatment", overview: "Overview", theTreatment: "The treatment", benefits: "Key Benefits", procedureEye: "The Procedure", procedureTitle: "How it ", procedureGold: "works.", recoveryEye: "Recovery & Aftercare", recoveryTitle: "Healing in comfort", faqTitle: "Questions & ", faqGold: "answers.", ctaPre: "Ready for your", ctaP: "Speak with our concierge team and book your private consultation today.", allServices: "All Services", explore: "Explore More", discover: "Discover", servicesTitle1: "Every treatment, an", servicesTitle2a: "exercise in ", servicesTitle2gold: "excellence.", servicesLead: "Explore Glamour Dent's full range of luxury dental services — implants, veneers, whitening, orthodontics and more.", notSurePre: "Not sure where to ", notSureGold: "begin?", notSureP: "Our concierge team will guide you to the perfect treatment. One call is all it takes.", home: "Home", services: "Services", call: "Call", videoEye: "Watch", videoTitle: "See the results" },
};

const RO_BODY = {
  "dental-implants": {
    benefits: ["Soluție permanentă, care poate dura o viață", "Păstrează osul și structura feței", "Reface complet forța de mușcare și încrederea", "Imposibil de deosebit de dinții naturali"],
    procedure: [
      { t: "Evaluare 3D", d: "O scanare CT detaliată cartografiază osul și nervii pentru o plasare precisă, ghidată." },
      { t: "Plasarea implantului", d: "Șurubul din titan este plasat sub anestezie locală blândă, într-o singură vizită confortabilă." },
      { t: "Vindecare & integrare", d: "Implantul se integrează cu osul în câteva săptămâni, formând o bază stabilă." },
      { t: "Coroana finală", d: "O coroană din porțelan personalizată este fixată și asortată cromatic zâmbetului tău." },
    ],
    recovery: "Majoritatea pacienților revin la activitățile zilnice a doua zi. Umflarea ușoară dispare în 48 de ore, iar echipa noastră oferă un plan alimentar și controale prioritare pe parcursul integrării.",
    faq: [
      { q: "Implanturile dor?", a: "Plasarea se face sub anestezie locală — majoritatea pacienților resimt un disconfort minim ulterior." },
      { q: "Cât durează un implant?", a: "Cu o îngrijire bună, implanturile pot dura o viață. Coroana poate fi înnoită după 15–20 de ani." },
    ],
  },
  "teeth-whitening": {
    benefits: ["Rezultate vizibile într-o singură ședință", "Sistem sigur pentru smalț, supravegheat de medic", "Luminozitate uniformă și naturală", "Kit de întreținere la domiciliu inclus"],
    procedure: [
      { t: "Analiza nuanței", d: "Înregistrăm nuanța inițială și stabilim o țintă realistă și flatantă." },
      { t: "Protecția gingiei", d: "O barieră protectoare îți protejează gingiile pentru un confort total." },
      { t: "Activare", d: "Un gel de albire premium este activat în cicluri blânde." },
      { t: "Dezvăluirea", d: "Îți arătăm noua nuanță și adaptăm gutierele de întreținere." },
    ],
    recovery: "Nu există perioadă de recuperare. Unii pacienți observă o sensibilitate scurtă care dispare într-o zi; recomandăm o dietă deschisă la culoare timp de 24 de ore.",
    faq: [
      { q: "Albirea e sigură pentru smalț?", a: "Da — sistemul nostru supravegheat, de grad medical, este conceput să protejeze smalțul în timp ce îndepărtează petele." },
      { q: "Cât durează rezultatele?", a: "De obicei 12–18 luni, ușor de prelungit cu kitul de întreținere la domiciliu." },
    ],
  },
  "veneers": {
    benefits: ["Transformă forma, nuanța și alinierea deodată", "Tehnică minim-invazivă, care păstrează dintele", "Porțelan rezistent la pete, aspect natural", "Un design de zâmbet complet personalizat"],
    procedure: [
      { t: "Design-ul zâmbetului", d: "Proiectăm digital noul tău zâmbet și ți-l arătăm înainte de a începe." },
      { t: "Preparare delicată", d: "Se rafinează un strat minim pentru a face loc porțelanului." },
      { t: "Realizare de maestru", d: "Ceramiștii creează manual fiecare fațetă pentru o translucență naturală." },
      { t: "Fixare", d: "Fațetele sunt fixate cu precizie și lustruite la un finisaj impecabil." },
    ],
    recovery: "Poți mânca și vorbi normal în aceeași zi. Este normal să te obișnuiești cu noua senzație în câteva zile; nu există o perioadă de repaus semnificativă.",
    faq: [
      { q: "Fațetele vor arăta natural?", a: "Absolut — stratificăm porțelanul pentru a imita translucența naturală și proiectăm în jurul trăsăturilor feței tale." },
      { q: "Fațetele îmi strică dinții?", a: "Tehnica noastră minim-invazivă păstrează cât mai mult din structura naturală a dintelui." },
    ],
  },
  "orthodontics": {
    benefits: ["Aligneri transparenți, practic invizibili", "Detașabili pentru masă și igienă", "Rezultate previzibile, planificate digital", "Mai puține vizite decât aparatele clasice"],
    procedure: [
      { t: "Scanare digitală", d: "O scanare intraorală rapidă construiește un model 3D precis al ocluziei." },
      { t: "Previzualizarea tratamentului", d: "Vezi o simulare a zâmbetului final înainte de a începe." },
      { t: "Seria de aligneri", d: "Porți o succesiune de aligneri personalizați, fiecare mișcând delicat dinții." },
      { t: "Contenție", d: "Un retainer discret îți menține noul zâmbet perfect aliniat." },
    ],
    recovery: "Alignerii provoacă doar o presiune scurtă la schimbarea gutierelor. Viața de zi cu zi continuă neîntrerupt pe tot parcursul tratamentului.",
    faq: [
      { q: "Cât durează tratamentul?", a: "Majoritatea cazurilor se finalizează în 6–14 luni, în funcție de complexitate." },
      { q: "Alignerii îmi afectează vorbirea?", a: "Orice ajustare scurtă dispare de obicei într-o zi sau două de purtare." },
    ],
  },
  "dental-hygiene": {
    benefits: ["Îndepărtează placa, tartrul și petele de suprafață", "Protejează împotriva bolii gingivale și a cariilor", "Zâmbet proaspăt, lustruit și sănătos", "Sfaturi personalizate de îngrijire acasă"],
    procedure: [
      { t: "Evaluare", d: "Verificăm sănătatea gingiilor și depistăm eventualele probleme timpurii." },
      { t: "Curățare profundă", d: "Detartrajul ultrasonic blând îndepărtează depunerile cu confort total." },
      { t: "Lustruire & prospețime", d: "O lustruire fină ridică petele de suprafață pentru un finisaj luminos." },
      { t: "Îndrumare", d: "Sfaturi personalizate îți păstrează zâmbetul impecabil între vizite." },
    ],
    recovery: "Nu există deloc perioadă de recuperare — pleci cu un zâmbet proaspăt, lustruit, și îți poți relua imediat ziua.",
    faq: [
      { q: "Cât de des ar trebui să vin?", a: "Recomandăm o ședință de igienă la fiecare șase luni, sau mai des pentru planuri personalizate." },
      { q: "Detartrajul este inconfortabil?", a: "Tehnica noastră ultrasonică blândă este concepută pentru o experiență confortabilă și relaxantă." },
    ],
  },
  "prosthetics": {
    benefits: ["Reface complet funcția de masticație", "Porțelan lucrat manual, asortat cromatic", "Materiale durabile, de lungă durată", "Potrivire naturală și confortabilă"],
    procedure: [
      { t: "Evaluare", d: "Evaluăm dintele și proiectăm restaurarea ideală." },
      { t: "Preparare de precizie", d: "Dintele este modelat delicat pentru o potrivire durabilă și perfectă." },
      { t: "Realizare de maestru", d: "Ceramiștii construiesc proteza pentru rezistență și frumusețe." },
      { t: "Fixare", d: "Restaurarea este fixată, ajustată și lustruită la perfecțiune." },
    ],
    recovery: "Restaurările provizorii îți permit să funcționezi normal între vizite. Odată fixată piesa finală, poți mânca și zâmbi cu încredere deplină imediat.",
    faq: [
      { q: "Cât durează coroanele?", a: "Cu o îngrijire bună, coroanele de porțelan de calitate durează de obicei 15 ani sau mai mult." },
      { q: "Se va asorta cu ceilalți dinți?", a: "Da — fiecare restaurare este asortată cromatic și modelată pentru a se integra perfect." },
    ],
  },
  "endodontics": {
    benefits: ["Îți salvează dintele natural", "Elimină durerea și infecția", "Precizie ghidată la microscop", "Îngrijire confortabilă și blândă"],
    procedure: [
      { t: "Diagnostic", d: "Imagistica digitală identifică sursa disconfortului." },
      { t: "Acces blând", d: "Dintele este anesteziat și deschis delicat sub microscop." },
      { t: "Curățare & sigilare", d: "Canalele sunt curățate, modelate și sigilate meticulos." },
      { t: "Restaurare", d: "Dintele este reconstruit, adesea cu o coroană protectoare." },
    ],
    recovery: "Cel mai adesea disconfortul dispare într-o zi sau două. De obicei sunt suficiente analgezice uzuale, iar noi programăm un control prioritar pentru a confirma vindecarea completă.",
    faq: [
      { q: "Tratamentul de canal doare?", a: "Tratamentele moderne de canal nu sunt mai inconfortabile decât o plombă și, de fapt, elimină durerea existentă." },
      { q: "Voi avea nevoie de o coroană după?", a: "Deseori da — o coroană protejează dintele tratat și îi reface rezistența deplină." },
    ],
  },
  "pediatric-dentistry": {
    benefits: ["Specialiști calzi, prietenoși cu copiii", "Îngrijire preventivă și îndrumare blândă", "Mediu calm și liniștitor", "Formează obiceiuri sănătoase pe viață"],
    procedure: [
      { t: "Întâmpinare prietenoasă", d: "Îi prezentăm copilului cabinetul în ritmul lui." },
      { t: "Control blând", d: "O examinare relaxată și jucăușă a dinților în creștere." },
      { t: "Îngrijire preventivă", d: "Curățare, sigilanți și fluorizare pentru a proteja zâmbetele mici." },
      { t: "Obiceiuri fericite", d: "Îndrumare distractivă despre periaj și alimentație pentru părinți și copii." },
    ],
    recovery: "Vizitele de rutină nu necesită perioadă de recuperare. Trimitem mereu copilul acasă cu un zâmbet și cu sfaturi simple și utile pentru părinți.",
    faq: [
      { q: "Când ar trebui prima vizită a copilului?", a: "Recomandăm prima vizită până la vârsta de un an, sau imediat ce apar dinții." },
      { q: "Cum abordați copiii anxioși?", a: "Specialiștii noștri sunt instruiți în tehnici blânde și pozitive pentru a construi încredere și confort." },
    ],
  },
  "oral-surgery": {
    benefits: ["Specialiști chirurgicali experți", "Anestezie eficientă și confort", "Tehnici precise, minim-invazive", "Sprijin complet post-operator"],
    procedure: [
      { t: "Consultație", d: "Imagistica 3D planifică cea mai sigură și precisă abordare." },
      { t: "Confortul pe primul loc", d: "Anestezia locală asigură un confort total." },
      { t: "Procedura", d: "Intervenția se realizează cu o tehnică meticuloasă și blândă." },
      { t: "Îngrijire post-operatorie", d: "Un plan clar de recuperare și controale prioritare." },
    ],
    recovery: "Recuperarea variază în funcție de procedură, dar durează de obicei câteva zile de repaus și alimente moi. Oferim îndrumări detaliate și rămânem disponibili pe tot parcursul.",
    faq: [
      { q: "Voi simți durere în timpul intervenției?", a: "Nu — intervențiile se realizează sub anestezie locală eficientă, pentru un confort deplin pe tot parcursul." },
      { q: "Cât durează recuperarea?", a: "Majoritatea pacienților se recuperează în câteva zile, cu planul nostru structurat de îngrijire." },
    ],
  },
  "emergency-dentistry": {
    benefits: ["Programări urgente în aceeași zi", "Alinarea rapidă a durerii", "Îngrijire empatică și calmă", "Planificare completă a tratamentului ulterior"],
    procedure: [
      { t: "Contact imediat", d: "Sună la recepția noastră și îți acordăm prioritate." },
      { t: "Evaluare rapidă", d: "Diagnosticăm rapid problema și îți alinăm durerea." },
      { t: "Stabilizare", d: "Tratăm urgența și protejăm dintele." },
      { t: "Plan pentru viitor", d: "Programăm orice control necesar pentru a reface sănătatea deplină." },
    ],
    recovery: "După alinarea urgenței, recuperarea depinde de tratamentul aplicat. Îți prezentăm mereu pașii următori clari și programăm rapid îngrijirea ulterioară.",
    faq: [
      { q: "Ce se consideră urgență?", a: "Durerea severă, umflarea, sângerarea, traumatismele sau un dinte spart ori căzut necesită îngrijire urgentă." },
      { q: "Cât de repede pot fi văzut?", a: "Rezervăm locuri în aceeași zi pentru urgențe — sună imediat la linia noastră." },
    ],
  },
  "consultations": {
    benefits: ["Evaluare individuală, fără grabă", "Diagnostic digital complet", "Un plan clar și personalizat", "Costuri și opțiuni transparente"],
    procedure: [
      { t: "Conversație", d: "Ascultăm preocupările, obiectivele și istoricul tău." },
      { t: "Evaluare digitală", d: "Scanările și imagistica oferă o imagine completă a zâmbetului tău." },
      { t: "Planul tău", d: "Proiectăm un plan de tratament personalizat, pas cu pas." },
      { t: "Pașii următori", d: "Pleci cu opțiuni, termene și costuri clare." },
    ],
    recovery: "O consultație nu necesită perioadă de recuperare — este o vizită relaxată și informativă, care te lasă încrezător în privința opțiunilor și a pașilor următori.",
    faq: [
      { q: "Cât durează o consultație?", a: "De obicei 30–45 de minute, ca să putem evalua temeinic și să răspundem la fiecare întrebare." },
      { q: "Sunt obligat să continui tratamentul?", a: "Niciodată. Planul este oferit fără obligații, ca să poți decide în ritmul tău." },
    ],
  },
  "restorative-dentistry": {
    benefits: ["Plombe naturale, de culoarea dintelui", "Tehnică blândă, minim-invazivă", "Reface complet rezistența și funcția", "Materiale moderne, fără mercur"],
    procedure: [
      { t: "Diagnostic", d: "Depistăm caria din timp printr-o examinare atentă și imagistică." },
      { t: "Preparare blândă", d: "Zona este anesteziată și caria îndepărtată delicat." },
      { t: "Restaurare", d: "Un material de culoarea dintelui este stratificat și modelat." },
      { t: "Lustruire", d: "Restaurarea este lustruită pentru a se integra perfect în zâmbet." },
    ],
    recovery: "Majoritatea plombelor nu implică perioadă de recuperare; o eventuală sensibilitate ușoară dispare într-o zi. De obicei poți mânca și bea la scurt timp după vizită.",
    faq: [
      { q: "Plombele voastre se observă?", a: "Nu — folosim compozit de culoarea dintelui, care se integrează invizibil cu dinții naturali." },
      { q: "Tratarea unei carii doare?", a: "Tratamentul se face sub anestezie locală și este de obicei foarte confortabil." },
    ],
  },
  "custom-appliances": {
    benefits: ["Potrivire precisă, pe bază de scanare digitală", "Protejează împotriva bruxismului și accidentărilor", "Design confortabil și discret", "Materiale durabile, de lungă durată"],
    procedure: [
      { t: "Scanare digitală", d: "O scanare rapidă și confortabilă îți captează ocluzia exactă." },
      { t: "Realizare personalizată", d: "Aparatul tău este realizat cu precizie milimetrică." },
      { t: "Adaptare", d: "Îl adaptăm și îl reglăm pentru un confort total." },
      { t: "Îndrumare pentru îngrijire", d: "Sfaturi simple îți mențin aparatul în stare perfectă." },
    ],
    recovery: "Nu există perioadă de recuperare — aparatele sunt gata de folosit imediat, cu o scurtă și naturală perioadă de acomodare pentru purtarea de noapte.",
    faq: [
      { q: "Ce aparate realizați?", a: "Gutiere de albire, gutiere de noapte pentru bruxism, protecții sportive și retainere, toate personalizate." },
      { q: "Cât durează?", a: "Cu o îngrijire bună, majoritatea aparatelor durează câțiva ani; te vom sfătui când e nevoie de înlocuire." },
    ],
  },
};

export const getServices = (lang) =>
  SERVICES.map((s) => (lang === "en" ? s : { ...s, ...RO_OVR[s.slug], ...(RO_BODY[s.slug] || {}) }));

export const getService = (lang, slug) => {
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return null;
  return lang === "en" ? s : { ...s, ...RO_OVR[slug], ...(RO_BODY[slug] || {}) };
};
